import { html, Alert } from "./ui.js";

/** Draw whatever the server refuses or cannot answer, rather than nothing. */
export function Unavailable({ r, what }) {
  if (r.loading) return html`<p className="sub">Loading ${what}…</p>`;
  const denied = /\b40[13]\b/.test(r.error || "");
  return html`<${Alert} tone=${denied ? "info" : "warn"}
    title=${denied ? "Not yours to see" : "Could not read " + what}
    say=${denied
      ? "Your grant does not carry the capability this panel needs. Nothing is hidden from you selectively — the whole panel is gated."
      : r.error || "The server did not answer."}/>`;
}
